export function formatTime(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  return (
    [year, month, day].map(formatNumber).join('/') +
    ' ' +
    [hour, minute, second].map(formatNumber).join(':')
  );
}

/**
 * 参数1：time 需要转换的时间毫秒数
 * 参数2：cFormat 需要转换的目标格式 默认是{y}-{m}-{d} {h}:{i}:{s}格式，可以不传
 * 示例：parseTime(1605605577249,'{y}/{m}/{d} {h}:{i}:{s}') =>  '2020/11/17 17:32:57'
 * 参数2可以只格式化年月日时分秒的部分数据,例如： parseTime(1605605577249,'本月是{m}月') => '本月是12月'
 *
 * **/
export function parseTime(time, cFormat) {
  if (!time) {
    return null;
  }
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime2(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  // const second = date.getSeconds();

  return (
    [year, month, day].map(formatNumber).join('.') +
    ' ' +
    [hour, minute].map(formatNumber).join(':')
  );
}

export function formatTimeNoHour(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return [year, month, day].map(formatNumber).join('.');
}

export function formatDateShort(date) {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  return (
    [month, day].map(this.formatNumber).join('/') +
    ' ' +
    [hour, minute].map(this.formatNumber).join(':')
  );
}

const formatNumber = (n) => {
  const str = n.toString();
  return str[1] ? str : '0' + str;
};

export function getQueryVariable(url, variable) {
  const query = url;
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

export function getQueryVariableByComma(url, variable) {
  const query = url;
  const vars = query.split(',');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

/* 获取当前页url*/
export function getCurrentPageUrl() {
  const pages = getCurrentPages(); // 获取加载的页面
  const currentPage = pages[pages.length - 1]; // 获取当前页面的对象
  const url = currentPage.route; // 当前页面url
  return url;
}

/* 获取当前页带参数的url*/
export function getCurrentPageUrlWithArgs() {
  const pages = getCurrentPages(); // 获取加载的页面
  const currentPage = pages[pages.length - 1]; // 获取当前页面的对象
  const url = currentPage.route; // 当前页面url
  const options = currentPage.options; // 如果要获取url中所带的参数可以查看options

  // 拼接url的参数
  let urlWithArgs = url + '?';
  for (const key in options) {
    const value = options[key];
    urlWithArgs += key + '=' + value + '&';
  }
  urlWithArgs = urlWithArgs.substring(0, urlWithArgs.length - 1);
  return urlWithArgs;
}

export function isHongKongMacaoTaiwanAddress(address) {
  let matched = false;
  const blockList = [
    '香港',
    '澳门',
    '台湾',
    '澳門',
    '台灣',
    '海外',
    'Hong Kong',
    'Taiwan',
    'Macao',
    'Macau',
    'overseas',
    'Overseas',
    'OverSeas',
  ];
  blockList.forEach((item) => {
    if (address.startsWith(item)) {
      matched = true;
    }
  });
  return matched;
}

export function isEmptyObject(data) {
  if (!data) {
    return true;
  }
  if (JSON.stringify(data) === '{}') {
    return true;
  }
  const arr = Object.keys(data);
  if (arr.length === 0) {
    return true;
  }
  return false;
}
export default {
  formatTime,
  formatTime2,
  formatTimeNoHour,
  parseTime,
  formatDateShort,
  getQueryVariable,
  getQueryVariableByComma,
  getCurrentPageUrl,
  getCurrentPageUrlWithArgs,
  isHongKongMacaoTaiwanAddress,
  isEmptyObject,
};
